import Formatter from '../../../helpers/Formatter'
import { GiftCardOptions, GiftCardType } from '../../GiftCards/types'

export function orderQuantity(singleOrder) {
	let count = 0
	singleOrder.orderItems.forEach(item => {
		count += parseInt(item.qty)
	})
	return count
}

export function itemOrItems(len) {
	if (len === 1) {
		return 'item'
	} else {
		return 'items'
	}
}

export const getGiftCardProductDetails = (giftCardOptions: GiftCardOptions) => {
	const amount = Formatter.formatCurrency(giftCardOptions.amount / 100)
	const { recipient, recipientType, senderName, customMessage } = giftCardOptions

	const giftDetails =
		recipientType === GiftCardType.Gift
			? {
					recipient,
					senderName,
					customMessage,
				}
			: undefined

	return {
		field: `${amount} Gift Card`,
		amount: giftCardOptions.amount,
		giftDetails,
	}
}
